var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNintendoSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#E60012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.571 206H165.763C187.98 206 206 188.094 206 166.019V89.9811C206 67.9057 187.98 50 165.763 50H141.447C140.83 50 140.46 50.4906 140.46 50.9811V204.896C140.46 205.509 140.954 206 141.571 206ZM171.44 120.028C180.204 120.028 187.362 127.142 187.362 135.849C187.362 144.557 180.204 151.67 171.44 151.67C162.677 151.67 155.518 144.557 155.518 135.849C155.642 127.142 162.677 120.028 171.44 120.028ZM73.4387 96.8491C73.4387 104.943 80.1038 111.566 88.25 111.566C96.3962 111.566 103.061 104.943 103.061 96.8491C103.061 88.7547 96.3962 82.1321 88.25 82.1321C79.9803 82.1321 73.4387 88.6321 73.4387 96.8491ZM123.55 50H89.2374C67.0204 50 49 67.9057 49 89.9811V166.019C49 188.094 67.0204 206 89.2374 206H123.55C124.167 206 124.661 205.509 124.661 204.896V51.1038C124.661 50.4906 124.167 50 123.55 50ZM112.072 193.491H89.2374C81.8318 193.491 74.9198 190.67 69.7358 185.396C64.5519 180.245 61.5896 173.377 61.5896 166.019V89.9811C61.5896 82.6226 64.4285 75.7547 69.7358 70.6038C74.9198 65.4528 81.8318 62.5094 89.2374 62.5094H112.072V193.491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNintendoSwitch);
export default __webpack_public_path__ + "static/media/logo-nintendo-switch.61193fa956f53a2df48ad9f42243204e.svg";
export { ForwardRef as ReactComponent };